import { useState } from 'react';
import { MessageSquareText } from 'lucide-react';
import RoleGate from '../../../components/RoleGate';
import type { CoachScope } from '../../../api/types';
import CoachDrawer from './CoachDrawer';

interface Props {
  scope: CoachScope;
  /** Render as an ordinary button in the page header instead of the floating one. */
  inline?: boolean;
  /** Inline only: a white header button with a chat icon and this label (design "Ask coach about 10B"). */
  label?: string;
}

export default function CoachLaunchButton({ scope, inline = false, label }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <RoleGate allow={['teacher', 'school_admin', 'counselor', 'school', 'admin']} fallback={<></>}>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={label ?? 'Open coach'}
        className={inline
          ? (label
            ? 'inline-flex min-h-[44px] items-center justify-center gap-2 rounded-[12px] border border-line-strong bg-surface px-4 text-sm font-semibold text-ink hover:bg-surface-2'
            : 'inline-flex min-h-[36px] items-center justify-center rounded-[12px] border border-accent bg-accent px-3 py-1 text-[13px] font-semibold text-navy hover:brightness-105')
          : 'fixed bottom-6 right-6 z-40 rounded-full bg-primary px-4 py-3 text-sm font-medium text-white shadow-lg hover:opacity-90'}
      >
        {inline && label && <MessageSquareText size={18} strokeWidth={1.8} aria-hidden />}
        {label ?? 'Coach'}
      </button>
      <CoachDrawer scope={scope} open={open} onClose={() => setOpen(false)} />
    </RoleGate>
  );
}
